import ProductDataSection from "./ProductDataSection";
import RelatedProducts from "./RelatedProducts";
import ReviewSection from "./ReviewSection";

import { useParams } from "react-router-dom";
import { useEffect } from "react";

// FrontEnd - Dummy Data
// import { productsData } from "../../assets/data/data";

// Backend Product Data
import { ShopContext } from "../Context/ShopContext";
import { useContext } from "react";

const Product = () => {
  const { id } = useParams(); //Get Product Id from URL

  const { products } = useContext(ShopContext);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]); // Re-run when product ID changes

  // console.log("Product component - ID from URL:", id);
  // console.log("Product component - All products:", products);

  const product = products.find((item) => {
    // console.log("Product component - Comparing:", {
    //   productId: item._id,
    //   urlId: id,
    // });
    return item._id === id;
  });

  if (!product) {
    return (
      <p className="text-3xl text-center text-rose-300 mt-20">
        Product Not Found !
      </p>
    );
  }

  return (
    <div className=" pt-10 transition-opacity ease-in duration-500 opacity-100">
      {/* --------------PRODUCT DATA -----------------*/}
      <ProductDataSection />

      {/*------------- Description & Review Section ------------*/}
      <ReviewSection />
      {/* ------------display related products------------------ */}
      <RelatedProducts category={product.category} />
    </div>
  );
};

export default Product;
